import React from "react";
import { EditableInfo } from "@icoach/components";
import { isEmpty } from "@util/utils";

const AgreedNotesBox = ({ className, agreedNotes, onEdit }) => {
	return (
		<EditableInfo label="約定事項" onEdit={onEdit} className={className} isMultiline>
			{!isEmpty(agreedNotes) ? (
				<ul className="list-default">
					{agreedNotes.map((note, i) => (
						<li key={i} className="mb-1">
							{note}
						</li>
					))}
				</ul>
			) : (
				<span className={"font-color-4"}>未設定</span>
			)}
		</EditableInfo>
	);
};

export default AgreedNotesBox;
